<template>
  <div class="c-table-cell creation-date-cell">
    <div class="c-table-cell__wrapper">
      <div class="creation-date-cell-icon">
        <candidates-status-icon
          :status="data.candidateState.value"
          :scheduled-date-time="data.candidateState.scheduledDateTime"
        />
      </div>
      <div>
        {{ data.value }}
      </div>
    </div>
  </div>
</template>

<script>
import CandidatesStatusIcon from "@/pages/staff/candidates/components/candidates-status-icon";

export default {
  components: {
    CandidatesStatusIcon,
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<style scoped>
.c-table-cell {
  display: flex;
}
.c-table-cell__wrapper {
  display: grid;
  grid-template-columns: 1rem auto;
  gap: 14px;
  font-size: 13px;
  padding: 10px;
}
.creation-date-cell-icon {
  display: flex;
  justify-content: center;
}
</style>
